import RoomEvent from '../../event/RoomEvent'
import AppDispatcher from '../../core/AppDispatcher'

const onEditChannelManager = value => {
  AppDispatcher.dispatchWithType(RoomEvent.onEditChannelManager, { value: value })
}

export default onEditChannelManager
